import React, { ReactElement, ReactNode } from 'react';

type CardProps = { children: ReactNode };

const Card = ({ children }: CardProps): ReactElement => {
  return <div className="bg-white border rounded shadow-lg">{children}</div>;
};

export default Card;
